<template>
    <div class="main-content">
        <div class="article" v-if="article">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
            <h1 class="title-pg" v-if="!article.hide_title">{{ article.transTitle}}</h1>
            <div class="body">
                <div class="content" v-if="!article.hide_content" v-html="article.transContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import CMS from '@/model/cms'

    export default {
        components: {
        },
        data: () => ({
            article: null,
            breadcrumbs: [],
        }),
        watch: {
            // при изменениях маршрута запрашиваем данные снова
            '$route': 'fetchData'
        },
        created () {
            this.scrollToTop()
        },
        methods: {
            fetchData() {
                CMS.loadPageBySlug(this.$route.params.slug)
                    .then(response => {
                        this.breadcrumbs = [
                            {
                                text: 'Главная',
                                disabled: false,
                                href: '/'
                            }
                        ];
                        this.article = response.data;
                        if (this.article) {
                            if (this.article.parent) {
                                var ParentBreadcrumb = {};
                                ParentBreadcrumb.text = this.article.parent.transTitle;
                                ParentBreadcrumb.disabled = false;
                                ParentBreadcrumb.href = '/blog/' + this.article.parent.slug;
                                this.breadcrumbs.push(ParentBreadcrumb);
                            }
                            var breadcrumb = {};
                            breadcrumb.text = this.article.transTitle;
                            breadcrumb.disabled = true;
                            this.breadcrumbs.push(breadcrumb);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            // Прокручивание к началу страницы
            scrollToTop () {
                window.scrollTo(0, 0)
            }
        },
        mounted() {
            this.fetchData()
        },
    }
</script>

<style lang="scss" scoped>
</style>
